import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { Container, Row } from 'reactstrap';
import { PageHeader, Section } from '../../../shared/components';
import PageHeaderSubtitle from '../../../shared/components/PageHeaderSubtitle';
import GeneralInformationTabContainer from '../../Operations/Operation/GeneralInformationTabContainer';
import MissionDocuments from './Documents';
import GeneralInfo from './GeneralInfo';
import Context from './MissionContext';

const Mission: React.FC = () => {
  const {
    data: { mission },
    loading,
  } = useContext(Context);
  const { t } = useTranslation();

  return (
    mission && (
      <Container>
        <PageHeader title={`${t('mission')} ${mission.number}`} backTimes={1}>
          <Link to={`/operations/${mission.operation.number}`}>
            <div className="mt-n2" style={{ color: '#0099d6', fontSize: '14px' }}>
              {mission.operation.number}
            </div>
          </Link>
          <PageHeaderSubtitle
            className="mb-0"
            items={[
              { value: mission.operation.name, label: 'operationName' },
              { value: mission.operation.stage, label: 'operationStage' },
            ]}
          />
          <PageHeaderSubtitle
            items={[
              { value: mission.type, label: 'missionType' },
              { value: mission.status, label: 'missionStatus' },
            ]}
          />
        </PageHeader>
        <Row>
          <Section>
            <GeneralInformationTabContainer operation={mission.operation} loading={loading} />
          </Section>
        </Row>
        <Row>
          <Section title="Mission Data">
            <div className="h-divisor" />
            <GeneralInfo mission={mission} />
            <h5 className="mb-3">{t('missionObjective')}</h5>
            <div className="h-divisor" />
            <div className="mb-4">
              <p>{mission.objective}</p>
            </div>
            <MissionDocuments />
          </Section>
        </Row>
      </Container>
    )
  );
};

export default Mission;
